import { RouteObject, Outlet, Navigate } from 'react-router-dom';
import type { RouterProps } from 'contracts/Router';
import {
  DocumentsListPage,
  DocumentCreationPage,
  DocumentUpdatePage,
} from 'pages/Documents';

const documentsRoutes = ({
  location,
  userBelongsToAnyOf,
}: RouterProps): RouteObject => ({
  path: 'documentacoes',
  element: userBelongsToAnyOf(
    'admin',
    'carrierMember',
    'companyMember',
    'warehouseMember',
    'checklistMember'
  ) ? (
    <Outlet />
  ) : (
    <Navigate to="/" state={{ from: location }} />
  ),
  children: [
    {
      path: '',
      element: <DocumentsListPage />,
    },
    {
      path: 'criar',
      element: userBelongsToAnyOf('admin') ? (
        <DocumentCreationPage />
      ) : (
        <Navigate to="/documentacoes" state={{ from: location }} />
      ),
    },
    {
      path: ':id/editar',
      element: userBelongsToAnyOf('admin') ? (
        <DocumentUpdatePage />
      ) : (
        <Navigate to="/documentacoes" state={{ from: location }} />
      ),
    },
  ],
});

export default documentsRoutes;
